import { render } from "./AuditView.vue?vue&type=template&id=4545d956&scoped=true"
import script from "./AuditView.vue?vue&type=script&lang=js"
export * from "./AuditView.vue?vue&type=script&lang=js"

import "./AuditView.vue?vue&type=style&index=0&id=4545d956&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4545d956"]])

export default __exports__